import React from 'react';
import { compose } from 'recompose';
import { Modal, Header, Icon, Button } from 'semantic-ui-react';
import { withLocale } from 'op/components/locale';

const ValidationErrorModal = ({ locale, open, onClose }) => {
    return (
        <Modal open={open} onClose={onClose} basic size="small">
            <Header 
                icon="warning sign" 
                content={locale.validationErrorHeader}
                style={{ fontSize: '24px' }} 
            />
            <Modal.Content>
                <div style={{ fontSize: '18px' }}>
                    {locale.thereAreFailedKPIs}
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color="red" inverted onClick={onClose}>
                    <Icon name="remove" /> {locale._system.close}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default compose(
    withLocale('stp.validation'),
)(ValidationErrorModal); 